import React from 'react'
import styled from 'styled-components'

import OptionalProductLink from '../../OptionalProductLink'

import productPlaceholderImage from '../../../img/product-image-placeholder.png'

export interface ItemImageProps {
  altText: string
  className?: string
  itemUrlKey: string | null | undefined
  src: string | null | undefined
}

const ItemImage: React.FC<ItemImageProps> = ({ altText, className, itemUrlKey, src }) => (
  <div className={className}>
    <OptionalProductLink urlKey={itemUrlKey}>
      <img alt={altText} src={src || productPlaceholderImage} />
    </OptionalProductLink>
  </div>
)

const StyledItemImage = styled(ItemImage)(({ theme }) => ({
  background: theme.colors.coolGray.cool150,
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '8px',
  overflow: 'hidden',
  width: '100%',
  img: {
    borderRadius: '4px',
    maxWidth: '519px',
    objectFit: 'contain',
    width: '100%',
  },
  '@media(min-width: 600px)': {
    marginBottom: 0,
  },
}))

export default StyledItemImage
